/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AccountDeletionTaskStatus } from './';
import {
    AccountDeletionTaskStatusFromJSON,
    AccountDeletionTaskStatusFromJSONTyped,
    AccountDeletionTaskStatusToJSON,
} from './';
import type { AccountDeletionWorkflowType } from './';
import {
    AccountDeletionWorkflowTypeFromJSON,
    AccountDeletionWorkflowTypeFromJSONTyped,
    AccountDeletionWorkflowTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface AccountDeletionTask
 */
export interface AccountDeletionTask {
    /**
     * The task ID
     * @type {string}
     * @memberof AccountDeletionTask
     */
    id: string;
    /**
     * 
     * @type {AccountDeletionWorkflowType}
     * @memberof AccountDeletionTask
     */
    workflowType: AccountDeletionWorkflowType;
    /**
     * 
     * @type {AccountDeletionTaskStatus}
     * @memberof AccountDeletionTask
     */
    status: AccountDeletionTaskStatus;
    /**
     * 
     * @type {string}
     * @memberof AccountDeletionTask
     */
    accountId: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDeletionTask
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDeletionTask
     */
    identityId?: string;
    /**
     * 
     * @type {Date}
     * @memberof AccountDeletionTask
     */
    lastConnectionDateTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AccountDeletionTask
     */
    accountCreationDateTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AccountDeletionTask
     */
    creationDateTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof AccountDeletionTask
     */
    lastStatusChangeDateTime: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountDeletionTask
     */
    details?: Array<string>;
}

/**
 * Check if a given object implements the AccountDeletionTask interface.
 */
export function instanceOfAccountDeletionTask(value: object): value is AccountDeletionTask {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('workflowType' in value) || value['workflowType'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('creationDateTime' in value) || value['creationDateTime'] === undefined) return false;
    if (!('lastStatusChangeDateTime' in value) || value['lastStatusChangeDateTime'] === undefined) return false;
    return true;
}

export function AccountDeletionTaskFromJSON(json: any): AccountDeletionTask {
    return AccountDeletionTaskFromJSONTyped(json, false);
}

export function AccountDeletionTaskFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountDeletionTask {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'workflowType': AccountDeletionWorkflowTypeFromJSON(json['workflowType']),
        'status': AccountDeletionTaskStatusFromJSON(json['status']),
        'accountId': json['accountId'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'identityId': json['identityId'] == null ? undefined : json['identityId'],
        'lastConnectionDateTime': json['lastConnectionDateTime'] == null ? undefined : (new Date(json['lastConnectionDateTime'])),
        'accountCreationDateTime': json['accountCreationDateTime'] == null ? undefined : (new Date(json['accountCreationDateTime'])),
        'creationDateTime': (new Date(json['creationDateTime'])),
        'lastStatusChangeDateTime': (new Date(json['lastStatusChangeDateTime'])),
        'details': json['details'] == null ? undefined : json['details'],
    };
}

export function AccountDeletionTaskToJSON(value?: AccountDeletionTask | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'workflowType': AccountDeletionWorkflowTypeToJSON(value['workflowType']),
        'status': AccountDeletionTaskStatusToJSON(value['status']),
        'accountId': value['accountId'],
        'companyId': value['companyId'],
        'identityId': value['identityId'],
        'lastConnectionDateTime': value['lastConnectionDateTime'] == null ? undefined : ((value['lastConnectionDateTime']).toISOString()),
        'accountCreationDateTime': value['accountCreationDateTime'] == null ? undefined : ((value['accountCreationDateTime']).toISOString()),
        'creationDateTime': ((value['creationDateTime']).toISOString()),
        'lastStatusChangeDateTime': ((value['lastStatusChangeDateTime']).toISOString()),
        'details': value['details'],
    };
}

